import { WireAdapter } from "lwc";

export * from "./constants";

export type MediaQueryAdapterConfig = {
  media: string;
};

export type MediaQueryAdapterValue = {
  matches: boolean;
};

export class MediaQueryAdapter implements WireAdapter {
  mediaQuery: MediaQueryList = window.matchMedia("");
  private setValue: (value: MediaQueryAdapterValue) => void;

  constructor(setValue: (value: MediaQueryAdapterValue) => void) {
    this.setValue = setValue;
  }

  private onChange = (e: MediaQueryListEvent) => {
    this.setValue({ matches: e.matches });
  };

  connect() {
    this.setValue({ matches: this.mediaQuery.matches });
  }

  disconnect() {
    this.mediaQuery.removeEventListener("change", this.onChange);
  }

  update(config: MediaQueryAdapterConfig) {
    if (config.media !== this.mediaQuery.media) {
      this.mediaQuery.removeEventListener("change", this.onChange);
      this.mediaQuery = window.matchMedia(config.media);
      this.mediaQuery.addEventListener("change", this.onChange);
      this.setValue({ matches: this.mediaQuery.matches });
    }
  }
}
